/**
 * 供需列表页
 */
export const SUPPLY_DEMAND_LIST_PAGE_PATH = '/supplyDemand/list'

/**
 * 供需编辑页
 */
export const SUPPLY_DEMAND_EDIT_PAGE_PATH = '/supplyDemand/edit'

/**
 * 供需详情页
 */
export const SUPPLY_DEMAND_DETAIL_PAGE_PATH = '/supplyDemand/detail'
